import { memoAll } from '../../../CodesForFoundation';
import { round } from '../../../platform/geom/Math';
import { Matrix } from '../../../platform/geom/Matrix';
import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import {
    Figure, TransformHints, TransformScope
} from './Physical';
import { RectangularPhysical } from './RectangularPhysical';

export class FixedRectangular extends RectangularPhysical {

    @memoAll()
    public queryTransformHints(singular: boolean) {
        return TransformHints({
            scaleX: false,
            scaleY: false,
            rotate: false,
            translate: true,
            visible: !singular,
        });
    }

    public applyTransform(scope: TransformScope, mt: Matrix, from?: Figure): this {
        // from & to are always model level
        from = from ?? this.createFigure();
        const to = mt.apply(from);

        const width = Point.vector(from[0], from[1]).magnitude();
        const height = Point.vector(from[1], from[2]).magnitude();
        const center = Rect.fromPoints(this.modelLocalTransform().apply(to)).center();

        this.x = round(center.x - (width / 2), 4);
        this.y = round(center.y - (height / 2), 4);
        this.r = 0;
        this.width = width;
        this.height = height;
        return this;
    }
}

// const computeTransformForAnchor = (widthDelta: number, heightDelta: number, target: Physical) => {

//     let sx = 1;
//     let sy = 1;
//     let tx = 0;
//     let ty = 0;

//     // Left & Right
//     if ((target.anchor & AnchorFlags.left) && (target.anchor & AnchorFlags.right)) {
//         sx = (target.width + widthDelta) / target.width;
//     }
//     // Left
//     else if (target.anchor & AnchorFlags.left) {
//         // Do nothing...
//     }
//     // Right
//     else if (target.anchor & AnchorFlags.right) {
//         tx = widthDelta;
//     }
//     // None
//     else {
//         // tx = widthDelta / 2;

//         // sx = (target.width + widthDelta) / target.width;
//     }

//     // Top & Bottom
//     if ((target.anchor & AnchorFlags.top) && (target.anchor & AnchorFlags.bottom)) {
//         sy = (target.height + heightDelta) / target.height;
//     }
//     // Top
//     else if (target.anchor & AnchorFlags.top) {
//         // Do nothing...
//     }
//     // Bottom
//     else if (target.anchor & AnchorFlags.bottom) {
//         ty = heightDelta;
//     }
//     // None
//     else {
//         ty = heightDelta / 2;
//     }

//     const origin = target.position();

//     return Matrix.identity
//         .translate(origin)
//         .translate(tx, ty)
//         .scale(sx, sy)
//         .translate(origin.multiply(-1));
// };

